import {FC} from 'react'
import {EmptyState} from '../EmptyState'
import styles from '../../styles.module.css'

type Props = {
  user?: any
  onEdit?: () => void
}

const ROLE_LABEL: Record<string, string> = {
  CLIENTE: 'Cliente',
  EMPRESA: 'Empresa',
  FILIAL: 'Filial',
  ADMIN: 'Administrador',
  COLABORADOR: 'Colaborador',
}

const getInitials = (name?: string | null) => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return '?'
  return `${parts[0][0]}${parts.length > 1 ? parts[parts.length - 1][0] : ''}`.toUpperCase()
}

const UserResponsableClient: FC<Props> = ({user, onEdit}) => {
  if (!user) {
    return (
      <EmptyState
        icon='/media/icons/duotune/communication/com006.svg'
        title='Nenhum usuário de acesso'
        text='Sem usuário vinculado, o cliente não acessa o portal. Edite o cliente para criar ou vincular um usuário.'
      />
    )
  }

  const roleSlug = user.role?.slug || ''

  return (
    <>
      <button
        type='button'
        className={`${styles.userCard} ${styles.clickable}`}
        onClick={onEdit}
        title='Editar usuário'
      >
        <span className={styles.userAvatar}>{getInitials(user.name)}</span>
        <div className={styles.itemText}>
          <span className='fs-4 fw-bold text-gray-900 text-truncate'>
            {user.name || 'Usuário sem nome'}
          </span>
          <span className='text-muted fs-7 text-truncate'>{user.email || 'Sem e-mail'}</span>
        </div>
        {roleSlug && (
          <span className='badge badge-light-primary fs-8 fw-bold'>
            {ROLE_LABEL[roleSlug] || roleSlug}
          </span>
        )}
        <span className='d-inline-flex align-items-center gap-1 text-primary fs-7 fw-bold flex-shrink-0'>
          <i className='bi bi-pencil-square text-primary'></i>
          Editar
        </span>
      </button>

      <div className={styles.userDetails}>
        <div className={styles.detailBox}>
          <span className={styles.statLabel}>E-mail de acesso</span>
          <span className={styles.detailValue} title={user.email}>
            {user.email || 'Não informado'}
          </span>
        </div>
        <div className={styles.detailBox}>
          <span className={styles.statLabel}>Perfil</span>
          <span className={styles.detailValue}>
            {ROLE_LABEL[roleSlug] || roleSlug || 'Não informado'}
          </span>
        </div>
      </div>
    </>
  )
}

export {UserResponsableClient}
